import React, { MouseEvent } from 'react';
import { Button } from 'reactstrap';
import './DropdownMenuItem.scss';
import classnames from 'classnames';

type OuterProps = {
  icon?: string;
  name: string;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
};

export const DropdownMenuItem = ({
  icon,
  name,
  onClick,
  className,
}: OuterProps) => (
  <Button
    className={classnames('dropdown-menu__item', className)}
    onClick={onClick}
    onMouseDown={(e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();
    }}
  >
    {icon && <img src={icon} alt="" className="dropdown-menu__item-icon" />}
    {name && <span className="dropdown-menu__item-name">{name}</span>}
  </Button>
);
